import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const SupplyCodePage = () => {
  const columns = [
    { key: 'code', label: 'HCPCS Code' },
    { key: 'description', label: 'Description' },
    { key: 'category', label: 'Category' },
    { key: 'unitCost', label: 'Unit Cost' },
    { key: 'unitType', label: 'Unit Type' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', code: 'A4253', description: 'Blood glucose test strips', category: 'Diabetic Supplies', unitCost: '$0.50', unitType: 'Each', active: 'Yes' },
    { id: '2', code: 'A4256', description: 'Normal saline solution', category: 'IV Supplies', unitCost: '$5.00', unitType: 'Bag', active: 'Yes' },
    { id: '3', code: 'A4310', description: 'Catheter insertion tray', category: 'Catheter Supplies', unitCost: '$15.00', unitType: 'Each', active: 'Yes' },
    { id: '4', code: 'A6216', description: 'Gauze, non-impregnated', category: 'Wound Care', unitCost: '$2.00', unitType: 'Pack', active: 'Yes' },
    { id: '5', code: 'A6530', description: 'Compression bandage', category: 'Wound Care', unitCost: '$8.00', unitType: 'Each', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Supply Code"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Supply"
    />
  );
};

export default SupplyCodePage;
